// Lightweight client-side SEO/AEO helpers: meta tags, canonical, OG and JSON-LD injection.
const BASE = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang) {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Apply per-page meta, canonical, hreflang and Open Graph.
export function applySeo({ slug, seo = {}, lang = "de", siteName = "Dr. B.-Digitec", baseUrl = BASE, ogImage }) {
  const base = (baseUrl || BASE).replace(/\/$/, "");
  const path = !slug || slug === "home" ? "" : `/${slug}`;
  const canonical = lang === "en" ? `${base}${path}?lang=en` : (seo.canonical || `${base}${path}`);
  const title = seo.title || siteName;
  const desc = seo.description || seo.ai_summary || "";

  document.title = title;
  upsertMeta("name", "description", desc);
  upsertMeta("name", "keywords", seo.keywords);
  upsertMeta("name", "robots", seo.robots || "index,follow");
  upsertLink("canonical", canonical);
  upsertLink("alternate", `${base}${path}`, "de");
  upsertLink("alternate", `${base}${path}?lang=en`, "en");
  upsertLink("alternate", `${base}${path}`, "x-default");

  // Open Graph
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:site_name", siteName);
  upsertMeta("property", "og:title", seo.og_title || title);
  upsertMeta("property", "og:description", seo.og_description || desc);
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:locale", lang === "en" ? "en_US" : "de_DE");
  if (ogImage) upsertMeta("property", "og:image", ogImage);
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", seo.og_title || title);
  upsertMeta("name", "twitter:description", seo.og_description || desc);
}

// Inject (or replace) the per-page JSON-LD graph into the document head.
export function injectJsonLd(graph) {
  const ID = "ld-page";
  let el = document.getElementById(ID);
  if (!graph || !graph["@graph"] || graph["@graph"].length === 0) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = ID;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(graph);
}
